module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "preferences"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "wrapPreferences"
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.marketingPreferencePromotion')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.marketingPreferencePromotionExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "promotions",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    model: {
      value: (_vm.model.email_promotions),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_promotions", $$v)
      },
      expression: "model.email_promotions"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "promotions",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_promotions),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_promotions", $$v)
      },
      expression: "model.email_promotions"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.marketingPreferenceSurveys')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.marketingPreferenceSurveysExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "research",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    model: {
      value: (_vm.model.email_research),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_research", $$v)
      },
      expression: "model.email_research"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "research",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_research),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_research", $$v)
      },
      expression: "model.email_research"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.marketingPreferenceNewsletters')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.marketingPreferenceNewslettersExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "newsletter",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    model: {
      value: (_vm.model.email_newsletter),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_newsletter", $$v)
      },
      expression: "model.email_newsletter"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "newsletter",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_newsletter),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_newsletter", $$v)
      },
      expression: "model.email_newsletter"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.marketingPreferenceUpdates')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.marketingPreferenceUpdatesExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "updates",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    on: {
      "change": _vm.open
    },
    model: {
      value: (_vm.model.email_updates),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_updates", $$v)
      },
      expression: "model.email_updates"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "updates",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_updates),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_updates", $$v)
      },
      expression: "model.email_updates"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.communityEmailPreferences')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.communityEmailPreferencesExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "community",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    on: {
      "change": _vm.open
    },
    model: {
      value: (_vm.model.email_community),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_community", $$v)
      },
      expression: "model.email_community"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "community",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_community),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_community", $$v)
      },
      expression: "model.email_community"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btnwrap"
  }, [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "secondary": "",
      "label": _vm.$t('message.updateText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.savePreferences.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.$store.state.status.payment.paid) ? _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "Just a moment..."
    },
    on: {
      "close": _vm.close
    }
  }, [_vm._v("\n      Opting out will mean that you will no longer received Personalised Support emails which are included as part of the fee for the Low Carb Program. Are you sure you wish to opt out of this paid for feature?\n      "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "Opt out"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "Cancel"
    },
    on: {
      "click": _vm.closeSet
    },
    slot: "actions"
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be4efd4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Preferences.vue
// module id = 3623
// module chunks = 1